import { useCallback, useEffect } from "react";
import NameFormContainer from "./name-form-container";
import "./contact-container.css";

const ContactContainer = () => {
  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add("animate");
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);

  const onLinkedInIconClick = useCallback(() => {
    window.open("https://www.linkedin.com/in/sayan-das-115411244/");
  }, []);

  const onTwitterIconClick = useCallback(() => {
    window.open("https://twitter.com/SaYanDas242003");
  }, []);

  const onInstagramIconClick = useCallback(() => {
    window.open("https://www.instagram.com/sayan_ricky/");
  }, []);

  const onFacebookIconClick = useCallback(() => {
    window.open("https://www.facebook.com/profile.php?id=100069335347638");
  }, []);

  const onYouTubeIconClick = useCallback(() => {
    window.open("https://www.youtube.com/channel/UCqVu-DbkagYP2fgtNqSIZLw");
  }, []);

  return (
    <div
      className="frame-container"
      data-scroll-to="frameContainer"
      data-animate-on-scroll
    >
      <div className="contact-wrapper">
        <div className="contact1">Contact</div>
      </div>
      <div className="frame-child2" />
      <NameFormContainer
        inputValue="Name"
        inputPlaceholder="Type your name here... "
      />
      <NameFormContainer
        inputValue="Email"
        inputPlaceholder="Type your mail here..."
        propTop="314px"
        propHeight="91px"
        propHeight1="56px"
      />
      <NameFormContainer
        inputValue="Message"
        inputPlaceholder="Type your message here..."
        propTop="429px"
        propHeight="208px"
        propHeight1="173px"
      />
      <div className="image-9-wrapper">
        <img className="image-9-icon" alt="" src="/image-9@2x.png" />
      </div>
      <div className="linkedin-parent">
        <img
          className="linkedin-icon"
          alt=""
          src="/linkedin@2x.png"
          onClick={onLinkedInIconClick}
        />
        <img
          className="linkedin-icon"
          alt=""
          src="/twitter@2x.png"
          onClick={onTwitterIconClick}
        />
        <img
          className="linkedin-icon"
          alt=""
          src="/instagram@2x.png"
          onClick={onInstagramIconClick}
        />
        <img
          className="linkedin-icon"
          alt=""
          src="/facebook@2x.png"
          onClick={onFacebookIconClick}
        />
        <img
          className="linkedin-icon"
          alt=""
          src="/youtube@2x.png"
          onClick={onYouTubeIconClick}
        />
      </div>
    </div>
  );
};

export default ContactContainer;
